import CategorConnect from './category-connect';
import EffectData from './effect-data';

export default [
  {
    path: '/index',
    title: '品类关联',
    component: CategorConnect,
  },
  {
    path: '/effect-data',
    title: '效果数据',
    component: EffectData,
  },
];
